

export const getCrossPlatformInfo = () => {
  const platform = typeof process !== "undefined" && process.versions?.node ? "node" : "browser";
  const stage    = (platform === "browser" ? (globalThis as any)?.umi?.stage : process.env.STAGE) ?? "local";

  return {
    platform: platform as "browser" | "node",
    stage: stage as "dev" | "prod" | "local",
  };
};
